<script>
export default {
  props: {
    boleto: {
      type: [Object, Boolean],
      required: true
    }
  },

  methods: {
    copyToClipBoard() {
      const el = document.createElement("textarea");
      el.value = document.getElementById("line_code").innerHTML;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.$toasted.success("Linha de código copiada!");
    }
  }
};
</script>

<template>
  <section v-if="boleto.funding_instrument">
    <p class="mb-10">Baixe o boleto ou copie a linha digitável:</p>

    <a :href="boleto.funding_instrument.url_print" target="_blank" rel="noopener noreferrer">
      <div class="btn bg-pink-outline">
        Baixar boleto
        <img src="/static/download.svg" height="15px" class="ml-10" />
      </div>
    </a>

    <div class="boleto-info">
      <div class="line-code">
        <b id="line_code">{{boleto.funding_instrument.line_code}}</b>
        <div class="copy-button" @click="copyToClipBoard">copiar</div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.btn-checking {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.btn {
  margin-left: 0;
  margin-right: 0;
}

p {
  font-size: 14px;
  text-align: center;
}

section {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.border-bottom {
  border-bottom: 1px solid #ddd;
}

.payment-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 10px 0;
  text-transform: uppercase;
  font-size: 22px;
  font-weight: 700;
}

.payment-title::after {
  content: "";
  text-align: center;
  display: block;
  width: 200px;
  margin-top: 10px;
  border-bottom: 1px solid var(--pink);
}

.accept {
  color: var(--pink);
  font-size: 14px;
  font-weight: 300;
  line-height: 16px;
  padding: 3px 7px;
  font-style: italic;
  text-align: center;
}

.normal {
  font-style: normal;
}

.boleto-info {
  font-size: 14px;
  font-family: "Roboto";
  color: #333;
  font-weight: 300;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  margin-top: 0;
  margin-bottom: 5px;
}

.line-code {
  margin-top: 5px;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  justify-content: center;
}

.line-code b {
  font-weight: 700;
  padding: 5px 10px;
  background-color: #eee;
  border-radius: 4px 4px 0 0;
}

.line-code .copy-button {
  background-color: #e3e3e3;
  padding: 5px 10px;
  border-radius: 0 0 4px 4px;
  cursor: pointer;
  transition: all 0.24s ease;
}
.line-code .copy-button:hover {
  background-color: #c9c9c9;
}

.btn-copy {
  transition: 0s;
}

@media (min-width: 668px) {
  section {
    align-items: center !important;
  }

  .line-code {
    flex-direction: row;
  }

  .line-code b {
    border-radius: 4px 0 0 4px;
  }

  .line-code .copy-button {
    border-radius: 0 4px 4px 0;
  }

  .boleto-info {
    font-size: 16px;
  }

  .btn {
    margin-left: 5px;
    margin-right: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/CheckoutMobile/Boleto.vue